// beta flags to test/deploy new code selectively

// Revert asterisk diff to the legacy FragmentDiff algorithm
export const LEGACY_ASTERISK_DIFF = 'legacy-asterisk-diff'

// Revert to the old pagination plugin (the policy-based,
// dialogue-continueds-aware one is now the default)
export const LEGACY_PAGINATOR = 'legacy-paginator'

export type Feature = typeof LEGACY_ASTERISK_DIFF | typeof LEGACY_PAGINATOR

export function reverseFlag(flag: Feature) {
  return ['no', flag].join('-')
}
